export default {
    label: 'Kontaktujte nás',
    description: 'Vážený kliente, obraťte se prosím na naše Kontaktní centrum +420 296 333 666.',
    submitButton: 'Telefonovat'
}
